exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-tr.vipCtrl:after{content:\"vip\\7B49\\7EA7\\4E0D\\6EE1\\8DB3\";position:absolute;left:20px;width:100px;height:30px;display:block;text-align:center;line-height:30px;background-color:#fff6f6;border:1px solid #d71718;color:#000;opacity:.5;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;transform:rotate(-16deg);-ms-transform:rotate(-16deg);-moz-transform:rotate(-16deg);-webkit-transform:rotate(-16deg);-o-transform:rotate(-16deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6dd9ade","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/bizMsg/BizEventMsgTplSubscrSave.vue
// module id = 3951
// module chunks = 0